import {RxdbRepository} from "../rxdb/rxdb.repository";
import {HttpClient} from "@angular/common/http";
import {StandaloneModeService} from "../standalone-mode.service";
import {RemoteOpportunityManagerService} from "./_services/remote-opportunity-manager.service";
import {
    RxdbOfflineEquoteOpportunityRepository
} from "../rxdb/repositories/opportunities/offline-equote-opportunity.repository";
import {OfflineOpportunityManagerService} from "./_services/offline-opportunity-manager.service";

export const opportunityManagerServiceFactory = (standaloneModeService: StandaloneModeService, rxdbService: RxdbRepository, httpClient: HttpClient) => {
    return standaloneModeService.isOffline() ? new OfflineOpportunityManagerService(new RxdbOfflineEquoteOpportunityRepository(rxdbService)) : new RemoteOpportunityManagerService(httpClient);
}